/*
 * Update both enums! They hold the same values in reserved order
 */
export enum customFieldLocations {
    personal = 'personalCustomFields',
    job_and_pay = 'jobAndPayCustomFields',
}

export enum fieldLocationToComponent {
    personalCustomFields = 'personal',
    jobAndPayCustomFields = 'job_and_pay',
}
